import React, {useEffect} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import * as Sentry from "@sentry/react";
import ReactGA4 from 'react-ga4';
import {routesPrefix as routesPrefixEntities} from "@/App/Entities/routes/enums";
import {
    onChangeLocation as onChangeLocationProtectora,
    renderRoutesProtectora
} from "@/App/AdminProtectora/RouterProtectora";
import {
    onChangeLocation as onChangeLocationAdminProtectora,
    renderRoutesAdminProtectora
} from "@/App/AdminProtectora/RouterAdminProtectora";
import {onChangeLocation as onChangeLocationAnimals, renderRoutesAnimals} from "@/App/Animals/RouterAnimals";
import {onChangeLocation as onChangeLocationEntities, renderRoutesEntities} from "@/App/Entities/RouterEntities";

function RouterAdopta(props) {
    const location = useLocation()
    useEffect(() => {
        //https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen
        console.info('📍 -> location : ', location.pathname);
        onChangeLocation(location)
    }, [location])

    return (
        <>
            <Routes>
                {renderRoutesAnimals()}
                {renderRoutesEntities()}
                {renderRoutesAdminProtectora()}
                {renderRoutesProtectora()}
                <Route path='*' element={<Navigate to={routesPrefixEntities.rootBuscador}/>}/>
            </Routes>
        </>
    );
}

function onChangeLocation(location) {
    try {
        if (process.env.NODE_ENV === 'production' && (process.env.DEV_ENV === 'DEMO' || process.env.DEV_ENV === 'PRO')){
            // ReactGA.pageview(location.pathname);
            ReactGA4.send({hitType: "pageview", page: location.pathname});
        }
        onChangeLocationEntities(location)
        onChangeLocationAnimals(location)
        onChangeLocationAdminProtectora(location)
        onChangeLocationProtectora(location)

    } catch (e) {
        Sentry.captureException(e);
    }
}

export default RouterAdopta
